export const RADAR_MODES = {
  LIVE: "LIVE",
  STORED_PLAYBACK: "STORED_PLAYBACK",
  STORM_REPLAY: "STORM_REPLAY",
};

export const DEFAULT_RADAR_MODE = RADAR_MODES.LIVE;
